import { render } from "./CreateAppointments.vue?vue&type=template&id=e0aeea74&scoped=true"
import script from "./CreateAppointments.vue?vue&type=script&lang=js"
export * from "./CreateAppointments.vue?vue&type=script&lang=js"

import "./CreateAppointments.vue?vue&type=style&index=0&id=e0aeea74&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0aeea74"]])

export default __exports__